import { FormControl, InputLabel, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import { healthSystemTypes } from '../config/select';
import { CommonSelect } from 'component/select';
import { t } from 'i18next';
/**
 * A functional component that renders a selector for choosing a health system type.
 */
export const HealthSystemSelector = ({ values, handleChange }) => (
    <FormControl fullWidth>
        <InputLabel id="health-system-label">{t('users.fields.healthSystem')}</InputLabel>
        <CommonSelect
            id="health-system-label"
            name="healthSystemType"
            label={t('users.fields.healthSystem')}
            value={values.healthSystemType}
            onChange={handleChange}
            renderValue={(value) => {
                const selectedOption = healthSystemTypes.find(
                    (option) => option.value === value
                );
                return selectedOption ? selectedOption.name : '';
            }}
        >
            {healthSystemTypes.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.name}
                </MenuItem>
            ))}
        </CommonSelect>
    </FormControl>
);

HealthSystemSelector.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};
